import { lazy, Suspense } from "react";
import { Navigate, redirect } from "react-router-dom";

import NotFound from "@pages/404/not-found";
import Loading from "@components/loading";

import User from "@utils/user";

const loader = () => {
  const { token } = User.getUserInfoFromLocal();

  if (!token) return redirect("/login");

  return null;
};

const HelpCenter = lazy(() => import("@pages/help"));
const HelpDetail = lazy(() => import("@pages/help/detail"));
const AccountSetting = lazy(() => import("@pages/account-setting"));

const Home = lazy(() => import("@pages/home"));

const PurchaseOrder = lazy(() => import("@pages/order-center/purchase-order"));
const PurchaseDetail = lazy(
  () => import("@pages/order-center/purchase-order/detail")
);
const PurchaseReply = lazy(
  () => import("@pages/order-center/purchase-order/reply")
);
const ActiveProduct = lazy(
  () => import("@pages/product-center/active-product")
);
const ProductProposal = lazy(
  () => import("@pages/product-center/product-proposal")
);
const ProductProposalEdit = lazy(
  () => import("@pages/product-center/product-proposal/edit")
);

const ProductUpdate = lazy(
  () => import("@pages/product-center/product-update")
);

const NewUpdate = lazy(
  () => import("@pages/product-center/product-update/new")
);

const VendorDetails = lazy(() => import("@pages/vendor-details"));
const DeliveryAppointment = lazy(
  () => import("@pages/order-center/delivery-appointment")
);
export default [
  {
    path: "/",
    element: <Navigate to="/home" />,
    loader,
  },
  {
    path: "/user/settings/info",
    loader,
    element: (
      <Suspense fallback={<Loading />}>
        <AccountSetting />
      </Suspense>
    ),
  },
  {
    path: "/help-in",
    loader: () => {
      const { token } = User.getUserInfoFromLocal();
      if (!token) return redirect("/help-out/center");
      return null;
    },
    name: "Help",
    hideInMenu: true,
    children: [
      {
        path: "center",
        name: "Help Center",
        element: (
          <Suspense fallback={<Loading />}>
            <HelpCenter />
          </Suspense>
        ),
        hideInMenu: true,
      },
      {
        path: "center/detail",
        name: "Help Detail",
        element: (
          <Suspense>
            <HelpDetail />
          </Suspense>
        ),
        hideInMenu: true,
      },
    ],
  },

  {
    path: "/home",
    name: "Home",
    icon: "icon-home",
    loader,
    element: (
      <Suspense fallback={<Loading />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/order-center",
    name: "Order Center",
    icon: "icon-order",
    access: "order-center",
    children: [
      {
        path: "/order-center/purchase",
        name: "Purchase Order",
        element: (
          <Suspense fallback={<Loading />}>
            <PurchaseOrder />
          </Suspense>
        ),
        access: "vendor-page-purchase-order",
        loader,
      },
      {
        path: "/order-center/purchase/details",
        name: "Purchase Detail",
        element: (
          <Suspense fallback={<Loading />}>
            <PurchaseDetail />
          </Suspense>
        ),
        hideInMenu: true,
        access: "vendor-page-purchase-detail",
        loader,
      },
      {
        path: "/order-center/purchase/reply",
        name: "Purchase Reply",
        element: (
          <Suspense fallback={<Loading />}>
            <PurchaseReply />
          </Suspense>
        ),
        hideInMenu: true,
        access: "vendor-page-purchase-reply",
        loader,
      },
      {
        path: "/order-center/appointment",
        name: "Delivery Appointment",
        element: (
          <Suspense fallback={<Loading />}>
            <DeliveryAppointment />
          </Suspense>
        ),
        hideInMenu: false,
        loader,
      },
    ],
  },
  {
    path: "/product-center",
    name: "Product Center",
    icon: "icon-product-center",
    access: "Product-Center",
    children: [
      {
        path: "/product-center/list",
        name: "Active Product",
        element: (
          <Suspense fallback={<Loading />}>
            <ActiveProduct />
          </Suspense>
        ),
        access: "vendor-page-product-list",
        loader,
      },
      {
        path: "/product-center/proposal",
        name: "Product Proposal",
        element: (
          <Suspense fallback={<Loading />}>
            <ProductProposal />
          </Suspense>
        ),
        access: "vendor-page-proposal-list",
        loader,
      },
      {
        path: "/product-center/proposal/edit",
        name: "Proposal Edit",
        element: (
          <Suspense fallback={<Loading />}>
            <ProductProposalEdit />
          </Suspense>
        ),
        hideInMenu: true,
        access: "vendor-page-proposal-edit",
        loader,
      },
      {
        path: "/product-center/request",
        name: "Product Update",
        element: (
          <Suspense fallback={<Loading />}>
            <ProductUpdate />
          </Suspense>
        ),
        access: "vendor-page-request-list",
        loader,
      },
      {
        path: "/product-center/request/new",
        name: "New Update",
        hideInMenu: true,
        element: (
          <Suspense fallback={<Loading />}>
            <NewUpdate />
          </Suspense>
        ),
        access: "vendor-product-request-add",
        loader,
      },
    ],
  },
  {
    path: "/vendor",
    name: "Vendor Profile",
    icon: "icon-profile",
    access: "vendor-profile",
    children: [
      {
        path: "/vendor/details",
        name: "Vendor Details",
        access: "vendor-page-vendor-details",
        loader,
        element: (
          <Suspense fallback={<Loading />}>
            <VendorDetails />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
